// src/pages/admin/Page_Leads/Page_Leads.js
//
// Panel comercial agrupado (estrategia "wrap, don't rewrite", como M08/M11):
//   - Leads:          tabla original del panel comercial (LeadsBoard).
//   - Correos funnel: el editor del drip (Page_DripEditor embebido; su URL
//                     legacy /admin/drip redirige aqui y salio del menu).
//   - Promociones:    creador de promociones personales (PromotionsTab).
//   - Campanas:       envios masivos por lotes con freno por salud de SES.
// El tab activo se sincroniza con ?tab=... en la URL (compartible).

import React, { useMemo } from "react";
import { Tabs } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  ContactsOutlined,
  MailOutlined,
  GiftOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import { PageHeader } from "../../../ui";
import { LeadsBoard } from "./LeadsBoard";
import { PromotionsTab } from "./PromotionsTab";
import { CampaignsPanel } from "./CampaignsPanel";
// Alias PascalCase: la convencion Page_* del proyecto choca con
// react/jsx-pascal-case al usarse como JSX dentro de otra pagina.
import { Page_DripEditor as DripEditor } from "../Page_DripEditor/Page_DripEditor";
import "./Page_Leads.scss";

const LEADS_TABS = [
  {
    key: "leads",
    label: "Leads",
    icon: <ContactsOutlined />,
    render: () => <LeadsBoard />,
  },
  {
    key: "drip",
    label: "Correos funnel",
    icon: <MailOutlined />,
    render: () => <DripEditor embedded />,
  },
  {
    key: "promos",
    label: "Promociones",
    icon: <GiftOutlined />,
    render: () => <PromotionsTab />,
  },
  {
    key: "campanas",
    label: "Campanas",
    icon: <RocketOutlined />,
    render: () => <CampaignsPanel />,
  },
];

const DEFAULT_TAB = "leads";
const TAB_KEYS = new Set(LEADS_TABS.map((t) => t.key));

function normalizeTab(value) {
  return value && TAB_KEYS.has(value) ? value : DEFAULT_TAB;
}

export function Page_Leads() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeKey = normalizeTab(searchParams.get("tab"));

  const items = useMemo(
    () =>
      LEADS_TABS.map((t) => ({
        key: t.key,
        label: (
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
          >
            {t.icon}
            {t.label}
          </span>
        ),
        children: t.render(),
      })),
    [],
  );

  const onChange = (key) => {
    navigate(`/admin/leads?tab=${key}`, { replace: false });
  };

  return (
    <div className="page-leads-hub">
      <PageHeader
        title="Panel comercial"
        subtitle="Leads, correos del funnel y promociones Educacentro"
      />
      <Tabs
        activeKey={activeKey}
        onChange={onChange}
        items={items}
        destroyInactiveTabPane
      />
    </div>
  );
}
